import React from 'react';
import { Modal } from '@brighterion/br-ui';
import ScheduledDeploymentContent from './ScheduledDeploymentContent';

import styles from './ScheduledDeploymentModal.css';

export type ScheduledDeploymentModalProps = {
    closeModal: (isSubmit?: boolean) => void;
    modal: {
        id: string;
        name: string;
        title: string;
        operation: 'create' | 'update' | 'delete';
    };
    options: {
        isOpen: boolean;
    };
    status: 'warning' | 'success' | 'error' | 'info' | 'help';
    rulesType?: RulesType;
};

const ScheduledDeploymentModal = ({ closeModal, modal, options, status, rulesType }: ScheduledDeploymentModalProps) => {
    const { id } = modal;
    const { isOpen } = options;

    return (
        <Modal
            closeModal={closeModal}
            closeOnClickOutside={false}
            dataTestId={id}
            isOpen={isOpen}
            status={status}
            containerClass={styles.modal}
        >
            <ScheduledDeploymentContent closeModal={closeModal} modal={modal} status={status} rulesType={rulesType} />
        </Modal>
    );
};

export default ScheduledDeploymentModal;
